module.exports = __webpack_public_path__ + "media/app/assets/specializations/warlock/demonology-9b89a6a01dc92eb6c05a7d7ed3c4635f.png";